module.exports = __webpack_public_path__ + "img/event_main_img_chagne.2e9000f9.jpg";